import React from 'react';
import PropTypes from 'prop-types';

const AddFieldButton = ({ containerClassNames, onAddField, step }) => (
  <div className={containerClassNames}>
    <button
      className="btn btn-sm btn-outline-secondary"
      id={`step-${step}-add-field-btn`}
      type="button"
      onClick={onAddField}
    >
      + Add Field
    </button>
    <span className="text-secondary pl-2" style={{ fontSize: '14px' }}>
      (Taxi cannot save a form with empty steps)
    </span>
  </div>
);

AddFieldButton.propTypes = {
  containerClassNames: PropTypes.string.isRequired,
  onAddField: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
};

export default AddFieldButton;
